import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { SplitterModule } from 'primeng/splitter';
import { Subscription } from 'rxjs';
import { SOCKET_EVENTS, SocketService } from '../../../@core/services/socket.service';
import { ToastService } from '../../../@core/services/toast.service';
import { AiToolingService, ToolingAction } from '../../services/ai-tooling.service';
import { ButtonComponent } from '../../../@core/components/ui/button/button.component';
import { THREAD_STREAMING_STATUS } from 'src/app/features/general-agent/models/model';

@Component({
  selector: 'app-ai-tooling',
  standalone: true,
  imports: [CommonModule, FormsModule, ButtonModule, SplitterModule, ButtonComponent],
  templateUrl: './ai-tooling.component.html',
  styleUrl: './ai-tooling.component.scss'
})
export class AiToolingComponent implements OnInit, OnDestroy {
  @Input() contractId: string = "";
  @Input() role: string = "";

  promptText: string = "";
  currentAction!: ToolingAction;
  ToolingAction = ToolingAction;

  aiAssistant: { response: string; loading: boolean } = { response: '', loading: false };

  aiToolingSubscription!: Subscription;

  constructor(
    private aiToolingService: AiToolingService,
    private toast: ToastService,
    private socketService: SocketService
  ) { }

  ngOnInit(): void {
    this.aiToolingSubscription = this.socketService.on(SOCKET_EVENTS.AI_TOOLING).subscribe((res: any) => {
      const { status, content } = res[0];
      if (status === THREAD_STREAMING_STATUS.COMPLETED) {
        this.aiAssistant.loading = false;
      } else if (status === THREAD_STREAMING_STATUS.ERROR) {
        this.aiAssistant.loading = false;
        this.toast.error('Something went wrong, please try again');
      } else {
        this.aiAssistant.response = content;
        this.aiAssistant.loading = true;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.aiToolingSubscription) {
      this.aiToolingSubscription.unsubscribe();
    }
  }

  onActionClick(action: ToolingAction) {
    this.aiAssistant = { response: '', loading: true };
    this.currentAction = action;
    this.aiToolingService.runAITooling({
      query: this.promptText,
      action,
      documentId: this.contractId
    }).subscribe({
      error: () => {
        this.aiAssistant.loading = false;
        this.toast.error('Something went wrong, please try again');
      }
    });
  }

  copyResponseToClipboard() {
    navigator.clipboard.writeText(this.aiAssistant.response).then(() => {
      this.toast.success('Copied to clipboard');
    });
  }
}
